import ConfirmationModal from 'components/common/Confirmation';
import React, { useState } from 'react';
import { IconButton, ActionDropdown } from 'components/common';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import PositionGroupForm from './PositionGroupForm';
import { deletePositionGroup } from 'redux/organization/positionGroupSlice';
import PropTypes from "prop-types";
import { FaPlus, FaEdit, FaEllipsisV, FaTrashAlt } from 'react-icons/fa';

const PositionGroupHeader = ({ selected }) => {
  const [showConfirmationDelete, setShowConfirmationDelete] = useState(false);
  const [showFormPositionGroup, setShowFormPositionGroup] = useState(false);
  const [title, setTitle] = useState("");
  const [record, setRecord] = useState(null);

  const dispatch = useDispatch()

  const showForm = () => {
    setShowFormPositionGroup(true)
  }

  const handleNewPositionGroup = () => {
    setTitle("New Position group");
    showForm();
    setRecord(null);
  }

  const handleEditPositionGroup = () => {
    if (!validateSiteSelected()) return
    if (!validateSiteSelectedMultiple()) return

    setTitle("Edit Position group");
    showForm()
    setRecord(selected[0])
  }

  const handleDeleteSite = () => {
    if (!validateSiteSelected()) return
    if (!validateSiteSelectedMultiple()) return

    setShowConfirmationDelete(true)
    setRecord(selected[0])
  }

  const handleCloseConfirmation = () => {
    setShowConfirmationDelete(false)
  }

  const handleActionConfirm = async () => {
    dispatch(deletePositionGroup(record.id))
    setShowConfirmationDelete(false)
  }

  const validateSiteSelected = () => {
    if (selected.length === 0) {
      toast.error('Record has not selected yet.')
      return false
    }
    return true
  }

  const validateSiteSelectedMultiple = () => {
    if (selected.length > 1) {
      toast.error('You are selecting multiple records. Please select just one of record.')
      return false
    }
    return true
  }

  return (
    <>
      <div className="tw-bg-white tw-rounded tw-border tw-border-solid tw-border-slate-200 tw-shadow-sm tw-mb-3">
        <div className="tw-px-4 tw-py-3 tw-flex tw-justify-end tw-items-center tw-gap-1">
          <IconButton
            icon={<FaPlus size={12} />}
            variant="secondary"
            size="sm"
            className="tw-mr-1"
            onClick={handleNewPositionGroup}
          >
            <span className="tw-hidden xl:tw-inline-block tw-ml-1">New Position group</span>
          </IconButton>
          <IconButton
            icon={<FaEdit size={12} />}
            variant="secondary"
            size="sm"
            className="tw-mr-1"
            onClick={handleEditPositionGroup}
          >
            <span className="tw-hidden xl:tw-inline-block tw-ml-1">Edit</span>
          </IconButton>

          <ActionDropdown
            align="end"
            trigger={<FaEllipsisV size={12} />}
            items={[
              { label: 'Delete', icon: <FaTrashAlt size={13} />, danger: true, onClick: handleDeleteSite },
            ]}
          />
        </div>
      </div>

      {showConfirmationDelete && (
        <ConfirmationModal
          show={showConfirmationDelete}
          onHide={handleCloseConfirmation}
          onConfirm={handleActionConfirm}
          message="Are you sure to delete?"
        />
      )}

      {showFormPositionGroup && (
        <PositionGroupForm
          showModal={showFormPositionGroup}
          setshowModal={setShowFormPositionGroup}
          title={title}
          record={record}
        />
      )}

    </>
  );
};

PositionGroupHeader.propTypes = {
  selected: PropTypes.array.isRequired,
};

export default PositionGroupHeader;
